import React, { useId } from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { FormViewerContext, FormViewerHandle } from '@wix/form-viewer/widget';
import {
  FormValues,
  FormActions,
  FormConfig,
  FormResults,
} from '@wix/form-viewer';
import { Text } from 'wix-ui-tpa/cssVars';
import { WixForms } from '../../../../utils/state/types';
import WixForm from '../WixForm';
import { classes, st } from './BookerDetailsForm.st.css';
import { BookerDetailsFormDataHooks } from './dataHooks';

export interface BookerDetailsFormProps {
  formId: string;
  wixForms: WixForms;
  formValues: FormValues;
  handleFormChange: (values: FormValues) => void;
  onBusyChange?: (isBusy: boolean) => void;
  wixFormRef: React.RefObject<FormViewerHandle>;
  widgetProps: {
    host: React.ComponentProps<typeof FormViewerContext>['host'];
    wfActions: FormActions;
    wfConfig: FormConfig;
    wfResults: FormResults;
  };
}

const BookerDetailsForm: React.FC<BookerDetailsFormProps> = ({
  formId,
  wixForms,
  formValues,
  handleFormChange,
  onBusyChange,
  wixFormRef,
  widgetProps,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const fallbackCompId = useId();

  return (
    <section
      className={st(classes.root, { isMobile })}
      data-hook={BookerDetailsFormDataHooks.ROOT}
    >
      <Text
        tagName="h3"
        className={classes.title}
        data-hook={BookerDetailsFormDataHooks.TITLE}
      >
        {t('bookings.form.bookForSomeoneElse.bookerDetails.title')}
      </Text>
      <FormViewerContext
        host={widgetProps.host}
        wfActions={widgetProps.wfActions}
        wfResults={widgetProps.wfResults}
        wfConfig={{
          ...widgetProps.wfConfig,
          compId: `${widgetProps.wfConfig?.compId ?? fallbackCompId}-booker`,
        }}
      >
        <WixForm
          formId={formId}
          wixFormRef={wixFormRef}
          wixForms={wixForms}
          formValues={formValues}
          handleFormChange={handleFormChange}
          onBusyChange={onBusyChange}
        />
      </FormViewerContext>
    </section>
  );
};

export default BookerDetailsForm;
